export default __webpack_public_path__ + "static/media/brasao_governo_200.f6b72cb4.png";